import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

/**
 * Global Back button used in the AdminLayout header. Hidden on the
 * landing dashboard (nothing to go back to). Uses window.history.length
 * to only show when there is real history, otherwise renders nothing.
 */
export default function BackButton({ className = "" }) {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    // Hide on landing / login pages where there is nothing to go back to.
    const hideOn = ["/admin", "/admin/super/dashboard", "/login"];
    if (hideOn.includes(pathname)) return null;
    // If we have no history, sending navigate(-1) puts the user on a blank tab.
    // Bail out in that edge case.
    const hasHistory = typeof window !== "undefined" && window.history.length > 1;
    if (!hasHistory) return null;
    return (
        <button
            type="button"
            data-testid="global-back-btn"
            onClick={() => navigate(-1)}
            title="Go back to the previous page"
            className={`hidden items-center gap-1 rounded-full border border-slate-200 bg-white px-2.5 py-1 text-[11px] font-semibold text-slate-700 shadow-sm transition-colors hover:border-indigo-300 hover:bg-indigo-50 hover:text-indigo-700 md:inline-flex ${className}`}
        >
            <ArrowLeft size={12} weight="bold" />
            <span className="hidden sm:inline">Back</span>
        </button>
    );
}
